import { Navigate, useLocation } from 'react-router-dom';

/** Maps a legacy URL prefix onto the current product path, keeping the rest of the URL. */
export function LegacyPrefixRedirect({
  fromPrefix,
  toPrefix,
}: {
  fromPrefix: string;
  toPrefix: string;
}) {
  const { pathname, search } = useLocation();
  const rest = pathname.startsWith(fromPrefix) ? pathname.slice(fromPrefix.length) : '';
  return <Navigate to={`${toPrefix}${rest}${search}`} replace />;
}
